export default {
    name: 'userProfileSection',
    // created: {
    // },
    data() {
        return {
            firstName: "",
            lastName: "",
            Email: "",
            address: "",
            postalCode: ''
        };
    },
    created() {
        console.log("userInfo", this.$store.getters.getUserInfo);
        this.firstName = this.$store.getters.getUserInfo.firstName;
        this.lastName = this.$store.getters.getUserInfo.lastName;
        this.Email = this.$store.getters.getUserInfo.email;
        if (this.$store.getters.getUserInfo.address.exactAddress) {
            this.address = this.$store.getters.getUserInfo.address.exactAddress;
            this.postalCode = this.$store.getters.getUserInfo.address.postalCode;
        } else {
            this.address = 'Vous n\'avez pas encore ajouté une adresse de livraison par défaut.';
        }

        console.log('adr',this.address)
    },

};
